module.exports = __webpack_public_path__ + "img/under-maintenance-dark.9a52e9b5.svg";